"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findAttributeInDimension = exports.findMeasureGroupInDimensions = void 0;
var tslib_1 = require("tslib");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
//
// TODO: move all this code to data view facade.
//
//
function findInDimensionHeaders(dimensions, headerCallback) {
    for (var dimensionIndex = 0; dimensionIndex < dimensions.length; dimensionIndex++) {
        var dimension = dimensions[dimensionIndex];
        for (var headerIndex = 0; headerIndex < dimension.headers.length; headerIndex++) {
            var wrappedDescriptor = dimension.headers[headerIndex];
            var headerType = Object.keys(wrappedDescriptor)[0];
            var header = wrappedDescriptor[headerType];
            var headerCount = dimension.headers.length;
            var callbackResult = headerCallback(headerType, header, dimensionIndex, headerIndex, headerCount);
            if (callbackResult) {
                return callbackResult;
            }
        }
    }
    return null;
}
function findMeasureGroupInDimensions(dimensions) {
    return findInDimensionHeaders(dimensions, function (descriptorType, descriptor, _dimensionIndex, headerIndex, headerCount) {
        var measureGroupHeader = descriptorType === "measureGroupHeader" ? descriptor : null;
        if (measureGroupHeader) {
            ts_invariant_1.default(headerIndex === headerCount - 1, "MeasureGroup must be the last header in it's dimension");
        }
        return measureGroupHeader;
    });
}
exports.findMeasureGroupInDimensions = findMeasureGroupInDimensions;
function findAttributeInDimension(dimension, attributeHeaderItemsDimension, indexInDimension) {
    return findInDimensionHeaders([dimension], function (descriptorType, descriptor, _dimensionIndex, headerIndex) {
        if (descriptorType === "attributeHeader" &&
            (indexInDimension === undefined || indexInDimension === headerIndex)) {
            return tslib_1.__assign(tslib_1.__assign({}, descriptor), { 
                // attribute items are delivered separately from attributeHeaderItems
                items: attributeHeaderItemsDimension[indexInDimension ? indexInDimension : 0] });
        }
        return null;
    });
}
exports.findAttributeInDimension = findAttributeInDimension;
//# sourceMappingURL=executionResultHelper.js.map